export const initialFormValues = {
  stateRegistration: '',
  password: '',
  confirmPassword: '',
  selectAll: false,
  useTerms: false,
  useRegulation: false,
  usePrivacyPolicy: false,
  newsletter: false,
}

export const passwordRequirements = [
  {
    label: "Mínimo de 8 e máximo de 20 caracteres.",
    isValid: (password) => {
      if (!password) return null

      return password.length >= 8 && password.length <= 20
    },
  },
  {
    label: "No mínimo uma letra.",
    isValid: (password) => {
      if (!password) return null

      return /[a-zA-Z]/.test(password)
    },
  },
  {
    label: "No mínimo um número.",
    isValid: (password) => {
      if (!password) return null

      return /\d/.test(password)
    },
  },
  {
    label: "No mínimo 1 caractere especial.",
    isValid: (password) => {
      if (!password) return null

      return /[!@#$%^&*(),.?":{}|<>]/.test(password)
    },
  },
  {
    label: "Não deve conter mais de 3 números repetidos em ordem.",
    isValid: (password) => {
      if (!password) return null

      return !/(\d)\1{3,}/.test(password)
    },
  },
  {
    label: "Não deve conter mais de 3 números sequenciais.",
    isValid: (password) => {
      if (!password) return null

      const digits = password.replace(/\D/g, '')
      let sequentialCount = 1
      for (let i = 0; i < digits.length - 1; i++) {
        if (parseInt(digits[i]) + 1 === parseInt(digits[i + 1])) {
          sequentialCount++
          if (sequentialCount > 3) return false
        } else {
          sequentialCount = 1
        }
      }
      return true
    },
  },
];

export function countValidRequirements(password, userData) {
  return passwordRequirements.reduce((acc, requirement) => {
    return requirement.isValid(password, userData) ? acc + 1 : acc;
  }, 0);
}

export function getPasswordStrength(password, userData) {
  const validCount = countValidRequirements(password, userData);

  if (validCount <= 2) return 1;
  if (validCount <= 3) return 2;
  if (validCount <= 5) return 3;
  if (validCount === 6) return 4;

  return 5;
}

export const defaultToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6IkNTTTE4MDMiLCJzdWIiOiIxOTg5M2NiZS1mMTZiLTQ4YTctYWQ3Yi0zNTY0ZmI0MDliZWUiLCJuYW1lIjoiOTg0MzU4NzUwMjQiLCJnaXZlbl9uYW1lIjoiIiwiZW1haWwiOiIiLCJzc3RwIjoiWEdJNERXTFRQNENBWElLREJIQzVJV1gyQ1hGU0hFUVAiLCJzaWQiOiJFNENGM0JEMS0zNkE5LTQwMDgtODA2MS1FMUM3REZCOUFFMzciLCJjb21wYW55SWQiOiJHSzE4MDgiLCJjb21wYW55SW50ZXJuYWxOYW1lIjoiZ2VybWluaSIsIm5iZiI6MTc0OTY2NDI1MywiZXhwIjoyMDA4ODY0MjUzLCJpYXQiOjE3NDk2NjQyNTN9.jX7F-0JHxH_GfwnYeBUiPkDfS6m8Y722J_puV1s0GXs"





